/** @format */

import React, { Component } from "react";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

export default class HistorialCard extends Component {
  getArrayUniquePeriod = (arrayCourses) => {
    var periodos = [];
    arrayCourses.forEach((cursos) => {
      if (!periodos.includes(cursos.period)) {
        periodos.push(cursos.period);
      }
    });
    return periodos;
  };

  callColapsar = (art) => {
    let article = document.getElementById(art);
    article.classList.toggle("expanded");
  };

  render() {
    const dataHistorial =
      typeof this.props.objhistorial.courseArray != "undefined"
        ? this.props.objhistorial.courseArray
        : null;
    const arrayPeriodos =
      dataHistorial != null ? this.getArrayUniquePeriod(dataHistorial) : [];
    return (
      <div className=" mt-m4">
        {arrayPeriodos != null && arrayPeriodos.length != 0 ? (
          arrayPeriodos.map((periodo, i) => {
            return (
              <div key={i + "coursesCard"}>
                <div
                  className="card-header background-sub-cursos d-flex"
                  style={{ alignItems: "center" }}
                >
                  <div className="mr-auto p-2 historTitleL">
                    Periodo: {periodo}
                  </div>
                  {dataHistorial != null
                    ? dataHistorial
                        .filter((u) => u.period == periodo)
                        .map((courses, i) => {
                          return i == 0 ? (
                            <div className="ml-auto p-2 historTitleC" key={i}>
                              Promedio de periodo: {courses.averageSemester}
                            </div>
                          ) : (
                            ""
                          );
                        })
                    : null}

                  <div className="ml-3 p-2 historTitleR">
                    <ExpandMoreIcon
                      role="button"
                      style={{ color: "black" }}
                      onClick={() => this.callColapsar(`${i}_article`)}
                    ></ExpandMoreIcon>
                  </div>
                </div>
                {/*  */}
                <article id={`${i}_article`} className="article mt-2">
                  <div className="text-center mt-2">
                    <div className="row align-content-end">
                      <div className="col"></div>
                      <div className="col-10">
                        <table className="table">
                          <thead className="thead-light Historial-header">
                            <tr>
                              <th scope="col">Código</th>
                              <th scope="col">Curso</th>
                              <th scope="col">Crédito</th>
                              <th scope="col">Periodo</th>
                              <th scope="col">Estado</th>
                              <th scope="col">N° de Vez</th>
                              <th scope="col">Nota</th>
                            </tr>
                          </thead>
                          <tbody>
                            {dataHistorial != null ? (
                              dataHistorial
                                .filter((u) => u.period == periodo)
                                .map((courses, i) => {
                                  return (
                                    <tr key={i}>
                                      <td>{courses.courseId}</td>
                                      <td>{courses.courseName}</td>
                                      <td>{courses.credit}</td>
                                      <td>{courses.period}</td>
                                      <td>{courses.state}</td>
                                      <td>{courses.time}</td>
                                      <td>{courses.finalGrade}</td>
                                    </tr>
                                  );
                                })
                            ) : (
                              <tr key={i}>
                                <td colSpan={7} style={{ textAlign: "center" }}>
                                  No existe Historial...
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                      <div className="col"></div>
                    </div>
                  </div>
                </article>
              </div>
            );
          })
        ) : (
          <div style={{ textAlign: "center" }}>
            No existe Historial Academico...
          </div>
        )}
      </div>
    );
  }
}
